import React, { useEffect, useState } from "react";
import DashboardFilled from "./../assets/icons/dashboard_filled.svg";
import TradesFilled from "./../assets/icons/trades_filled.svg";
import ProductsFilled from "./../assets/icons/products_filled.svg";
import OrdersFilled from "./../assets/icons/orders_filled.svg";
import ShippingFilled from "./../assets/icons/shipping_filled.svg";
import CustomersFilled from "./../assets/icons/customers_filled.svg";
import RatesFilled from "./../assets/icons/rates_filled.svg";
import DashboardEmpty from "./../assets/icons/dashboard_empty.svg";
import TradesEmpty from "./../assets/icons/trades_empty.svg";
import ProductsEmpty from "./../assets/icons/products_empty.svg";
import OrdersEmpty from "./../assets/icons/orders_empty.svg";
import ShippingEmpty from "./../assets/icons/shipping_empty.svg";
import CustomersEmpty from "./../assets/icons/customers_empty.svg";
import RatesEmpty from "./../assets/icons/rates_empty.svg";
import SettingsEmpty from "./../assets/icons/settings_empty.svg";
import SettingsFilled from "./../assets/icons/settings_filled.svg";
import NotificationEmpty from "./../assets/icons/notification_empty.svg";
import NotificationFilled from "./../assets/icons/notification.svg";
import WithdrawalsEmpty from "./../assets/icons/withdrawals_empty.svg";
import WithdrawalsFilled from "./../assets/icons/withdrawals_filled.svg";
import CampaignsEmpty from "./../assets/icons/campaigns_empty.svg";
import CampaignsFilled from "./../assets/icons/campaigns_filled.svg";
import WatchlistEmpty from "./../assets/icons/watchlist_empty.svg";
import WatchlistFilled from "./../assets/icons/watchlist_filled.svg";
import MonitoringEmpty from "./../assets/icons/monitoring_empty.svg";
import MonitoringFilled from "./../assets/icons/monitoring_filled.svg";
import { NavLink } from "react-router-dom";
import MainRouter from "./router";
import { useQuery } from "react-query";
import { getSettings } from "../api/setting";

const Home = () => {
  const { data } = useQuery("settings", getSettings);
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const ls = localStorage.getItem("permissions");
    try {
      const parsedLs = JSON.parse(ls);
      setPermissions(parsedLs);
    } catch (error) {}
  }, []);

  const getModulePermission = (module, section) => {
    const pers = permissions?.find(
      (per) =>
        String(per?.module?.toLowerCase()) === String(module.toLowerCase()),
    )?.permissions;
    return pers ? pers[section] : false;
  };

  return (
    <div className="j-home bg-backgroundcolor w-full h-full min-h-screen">
      <div className="">
        <div className="md:bg-dark md:pt-7 md:w-[260px] h-full fixed mb-10 overflow-y-scroll">
          <div className="w-full h-full flex flex-col items-center">
            <div className="w-full px-10">
              <div className="text-[#6EEDC8] font-dmsans font-bold text-[16px]">
                Admin
              </div>
            </div>
            <div className="w-full h-full flex flex-col justify-between items-center md:mt-3 md:mb-10">
              <div className="w-full md:pr-10 pl-5">
                {getModulePermission("dashboard", "canView") && (

                <Navigation
                  icon={DashboardEmpty}
                  filled={DashboardFilled}
                  title={"Dashboard"}
                  to={"/"}
                />
                )}
                {getModulePermission("trade", "canView") && (
                  <Navigation
                    icon={TradesEmpty}
                    filled={TradesFilled}
                    title={"Trades"}
                    to={"/trades"}
                  />
                )}
                {/* <Navigation
                  icon={ProductsEmpty}
                  filled={ProductsFilled}
                  title={"Products"}
                  to={"/products"}
                /> */}
                {/* <Navigation
                  icon={OrdersEmpty}
                  filled={OrdersFilled}
                  title={"Orders"}
                  to={"/orders"}
                /> */}
                {/* <Navigation
                  icon={ShippingEmpty}
                  filled={ShippingFilled}
                  title={"Shipping"}
                  to={"/shipping"}
                /> */}
                {getModulePermission("Customer", "canView") && (
                  <Navigation
                    icon={CustomersEmpty}
                    filled={CustomersFilled}
                    title={"Customers"}
                    to={"/customers"}
                  />
                )}
                {getModulePermission("monitoring", "canView") && (
                  <Navigation
                    icon={MonitoringEmpty}
                    filled={MonitoringFilled}
                    title={"Monitoring"}
                    to={"/monitoring"}
                  />
                )}
                {getModulePermission("Watchlist", "canView") && (
                  <Navigation
                    icon={WatchlistEmpty}
                    filled={WatchlistFilled}
                    title={"BVN Watchlist"}
                    to={"/bvn-watchlist"}
                  />
                )}
                {getModulePermission("Withdrawal", "canView") && (
                  <Navigation
                    icon={WithdrawalsEmpty}
                    filled={WithdrawalsFilled}
                    title={"Withdrawals"}
                    to={"/withdrawals"}
                  />
                )}
                {getModulePermission("rate", "canView") && (
                  <Navigation
                    icon={RatesEmpty}
                    filled={RatesFilled}
                    title={"Rates"}
                    to={"/rates"}
                  />
                )}
              </div>
              <div className="w-full pr-10 pl-5">
                {getModulePermission("notification", "canView") && (
                <div className="w-full">
                  <Navigation
                    icon={NotificationEmpty}
                    filled={NotificationFilled}
                    title={"Notifications"}
                    to={"/notifications"}
                  />
                </div>
                )}
                {getModulePermission("notification", "canView") && (
                <div className="w-full">
                  <Navigation
                    icon={CampaignsEmpty}
                    filled={CampaignsFilled}
                    title={"Email Campaigns"}
                    to={"/email-campaigns"}
                  />
                </div>
                )}
                <div className="w-full">
                  <Navigation
                    icon={SettingsEmpty}
                    filled={SettingsFilled}
                    title={"Settings"}
                    to={"/settings"}
                  />
                </div>
                <div className="bg-white rounded-[8px]">
                  <div className="flex items-center p-3">
                    <div className="inline-flex items-center space-x-3">
                      <div className="">
                        <div className="w-[42px] h-[42px] flex justify-center items-center border-2 border-dark rounded-full">
                          <p className="text-center font-bold uppercase">
                            {data?.firstName?.charAt(0)}
                            {data?.lastName?.charAt(0)}
                          </p>
                        </div>
                      </div>
                      <div className="font-dmsans text-[13px] leading-[20.83px] text-dark font-bold capitalize">
                        {data?.firstName} {data?.lastName}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pl-[260px] w-full">
          <MainRouter />
        </div>
      </div>
    </div>
  );
};

export default Home;

function Navigation(props) {
  /**
   * props:
   * icon -> icon for the link
   * title -> title for the link
   * to -> the link
   */
  return (
    <div className="w-full my-4 select-none">
      <NavLink
        to={props.to}
        className={({ isActive }) =>
          isActive
            ? "block pl-5 rounded-[5px] bg-[#FFFFFF1A] py-2  w-full h-fit"
            : "navigation-link block pl-5 rounded-[5px]  py-2 w-full"
        }
        children={({ isActive }) => {
          return (
            <div className="flex items-center space-x-3 w-full">
              <div className="">
                <img
                  className="w-[24px] h-[24px]"
                  src={isActive ? props.filled : props.icon}
                  alt={props.title}
                />
              </div>
              <div
                className={
                  isActive
                    ? "font-dmsans text-[15px] text-white font-bold transition-all"
                    : "font-dmsans text-[15px] font-[400] text-white"
                }
              >
                {props.title}
              </div>
            </div>
          );
        }}
      />
    </div>
  );
}
